(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wachstoria-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wachstoria-guarantee')) {
    customElements.define('wachstoria-guarantee', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const viewport = this.querySelector('.wachstoria-guarantee__viewport');
        const graphic = viewport.querySelector('img');
        const trigger = this.querySelector('[data-guarantee-open]');
        if (!dialog.showModal) return;
        trigger.setAttribute('aria-haspopup', 'dialog');
        // Keep notice interactions local when opened inside the cart drawer.
        dialog.addEventListener('click', (event) => event.stopPropagation());
        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') event.stopPropagation();
        });
        let width = 800;
        const resize = (value) => {
          width = Math.min(1654, Math.max(Math.min(viewport.clientWidth, 800), value));
          graphic.style.width = `${width}px`;
        };
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          dialog.showModal();
          resize(800);
          viewport.scrollTo(0, 0);
        });
        this.querySelector('[data-guarantee-fit]').addEventListener('click', () => { resize(viewport.clientWidth); viewport.scrollTo(0, 0); });
        this.querySelector('[data-guarantee-read]').addEventListener('click', () => { resize(800); viewport.scrollTo(0, 0); });
        this.querySelector('[data-guarantee-zoom-out]').addEventListener('click', () => resize(width - 200));
        this.querySelector('[data-guarantee-zoom-in]').addEventListener('click', () => resize(width + 200));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
